import React from 'react';
import Config from '../utils/config';
import Label from '../utils/label';
import { dispatchAlert } from '../utils/site-utils';
import { getFullUrlPath, trim } from '../utils/common';
import $ from 'jquery';

export default class PopupKycReupload extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lbl_CallHelp: '',
            lbl_SabaDemoKYC04: Label.lbl_SabaDemoKYC04,
            KycFile: '',
			KycFileInfo: {
				preview: '',
				name: '',
				size: ''
			},
			KycfileError: false,
			KycfileErrorMessage: '',
            lbl_RegistrationField27: Label.lbl_RegistrationField27,
            lbl_RegistrationField28: Label.lbl_RegistrationField28,
            lbl_RegistrationField29: Label.lbl_RegistrationField29,
            lbl_RegistrationField30: Label.lbl_RegistrationField30,
            lbl_RegistrationField31: Label.lbl_RegistrationField31,
            lbl_RegistrationField32: Label.lbl_RegistrationField32,
            lbl_RegistrationField33: Label.lbl_RegistrationField33,
            lbl_RegistrationField34: Label.lbl_RegistrationField34,
            lbl_RegistrationField35: Label.lbl_RegistrationField35,
            lbl_RegistrationField36: Label.lbl_RegistrationField36,
            lbl_RegistrationField37: Label.lbl_RegistrationField37,
            lbl_RegistrationField38: Label.lbl_RegistrationField38,
            lbl_RegistrationField39: Label.lbl_RegistrationField39,
            lbl_RegistrationField40: Label.lbl_RegistrationField40,
            lbl_Submit: Label.lbl_Submit,
            SubmitStyle: 'disable'
        };
        this.KycFileInputRef = React.createRef();
    }

    popupDiv(type) {
        this.props.popupDiv(type);
    }

    handleBrowseClick = () => {
		this.KycFileInputRef.current.click();
	};

	handleFileChange = event => {
		const file = event.target.files[0];
		if (file) {
			const validTypes = ['image/jpeg', 'image/png'];
			const maxSize = 2 * 1024 * 1024;
			if (!validTypes.includes(file.type)) {
				this.setState({
					KycfileError: true,
					KycfileErrorMessage: this.state.lbl_RegistrationField35,
					KycFileInfo: {
						preview: '',
						name: '',
						size: ''
					},
					KycFile: ''
				});
                this.setState({ SubmitStyle: 'disable' });
				return;
			} else if (file.size > maxSize) {
				this.setState({
					KycfileError: true,
					KycfileErrorMessage: this.state.lbl_RegistrationField36,
					KycFileInfo: {
						preview: '',
						name: '',
						size: ''
					},
					KycFile: ''
				});
                this.setState({ SubmitStyle: 'disable' });
				return;
			}

			const reader = new FileReader();
			reader.onload = (e) => {
				this.setState({
					KycFileInfo: {
						preview: e.target.result,
						name: file.name,
						size: (file.size / 1024 / 1024).toFixed(2) + ' MB'
					},
					KycfileError: false,
					KycfileErrorMessage: '',
					KycFile: e.target.result,
				});
			};

			reader.readAsDataURL(file);
            this.setState({ SubmitStyle: '' });
		}
	};

	clearFile = () => {
		this.setState({
			KycFileInfo: {
				preview: '',
				name: '',
				size: ''
			},
			KycFile: '',
			KycfileError: false,
			KycfileErrorMessage: '',
		});
		this.KycFileInputRef.current.value = null;
        this.setState({ SubmitStyle: 'disable' });
	};

    sendSubmit = () => {
        if(this.state.SubmitStyle == 'disable')
            return;

        this.setState({ SubmitStyle: 'disable' });

        if (!this.state.KycFile || this.state.KycFile === '') {
            dispatchAlert(`${this.state.lbl_RegistrationField39}`);
            return;
        }

        $.ajax({
			type: 'post',
			contentType: 'application/json',
			url: getFullUrlPath('Register/ReUploadKycFile'),
			data: JSON.stringify({
				'KycFile': trim(this.state.KycFile)
			}),
			dataType: "text",
			async: false,
			cache: false,
			success: msg => {
				console.log(msg);
                msg = JSON.parse(msg);
				if (!msg.IsSuccess) {	                 		
                    this.setState({
                        KycfileError: true,
                        KycfileErrorMessage: msg.ErrorMsg,
                        KycFileInfo: {
                            preview: '',
                            name: '',
                            size: ''
                        },
                        KycFile: ''
                    });	
					dispatchAlert(`${msg.ErrorMsg}`);
                    this.setState({ SubmitStyle: '' });
				} else{
                    Config.appConfig.KycStatus = msg.KycStatus ? msg.KycStatus : 0;
                    this.popupDiv(-1);
                    console.log('Kyc Update Success!');
                }
			},
			error: (jqXHR, textStatus, errorThrown) => {
                this.clearFile();
                dispatchAlert(`${textStatus}`);
				console.error(jqXHR, textStatus, errorThrown);
			}
		});
    };

    render() {
        const _SiteId = Config.appConfig.SiteID;
        const { KycfileError, KycFileInfo, KycfileErrorMessage } = this.state;
        return (
            <div className="blocker blocker-audit">
                {_SiteId == '4245600' ? (
                    <div className="modal popup-audit">
                        <a
                            href="javascript:void(0);"
                            onClick={this.popupDiv.bind(this, -1)}
                            title="Close"
                            className="close"
                        >
                            <i className="icon-close" />
                        </a>

                        <div className="audit" >
                            <label>
                                <span class="mark">*</span>{this.state.lbl_SabaDemoKYC04}
                            </label>
                            {
                                (!KycFileInfo.preview && !KycfileError)
                                &&
                                <div className="audit__browse" onClick={this.handleBrowseClick}>
                                    <span className="audit__browse-text">{this.state.lbl_RegistrationField28}</span>
                                    <div className="audit__icon-file">
                                    </div>
                                </div>
                            }
                            {
                                KycfileError ?
                                    <div className="audit__file">
                                        <div className="audit__file-group">
                                            <div className="audit__icon-warning"></div>
                                            <span className="audit__error-text">{KycfileErrorMessage}</span>
                                        </div>
                                        <div className="audit__file-btn" onClick={this.handleBrowseClick}>{this.state.lbl_RegistrationField38}</div>
                                    </div> :
                                    KycFileInfo.preview && (
                                        <div className="audit__file">
                                            <div className="audit__file-group">
                                                <div className="audit__file-img">
                                                    <img id="file-preview" src={KycFileInfo.preview} alt="File Preview" />
                                                </div>
                                                <span id="file-name" className="audit__file-title">{KycFileInfo.name}</span>
                                                <span id="file-size" className="audit__file-text">{KycFileInfo.size}</span>
                                            </div>
                                            <div className="audit__file-btn" onClick={this.handleBrowseClick}>{this.state.lbl_RegistrationField38}</div>
                                            <div className="audit__icon-clear" onClick={this.clearFile}></div>
                                        </div>
                                    )
                            }

                            <div className="audit__item">
                                <div className="audit__item-title">{`${this.state.lbl_RegistrationField28}`}</div>
                                <ul>
                                    <li>{this.state.lbl_RegistrationField30}</li>
                                    <li>{this.state.lbl_RegistrationField31}</li>
                                    <li>{this.state.lbl_RegistrationField32}</li>
                                    <li>{this.state.lbl_RegistrationField33}</li>
                                    <li>{this.state.lbl_RegistrationField34}</li>
                                </ul>
                            </div>
                            <input
                                id="file-upload"
                                name="KycFileInfo"
                                type="file"
                                ref={this.KycFileInputRef}
                                className="audit__input-file"
                                accept=".jpg,.png"
                                style={{ display: 'none' }}
                                onChange={this.handleFileChange}
                            />

                            <div class={'btn btn-primary btn-block btn-large ' + this.state.SubmitStyle} onClick={this.sendSubmit}>{this.state.lbl_Submit}</div>
                        </div>
                    </div>
                ) : (
                    <div className="modal popup-audit">
                        <a
                            href="javascript:void(0);"
                            onClick={this.popupDiv.bind(this, -1)}
                            title="Close"
                            className="close"
                        >
                            <i className="icon-close" />
                        </a>
                        <h2>
                            <div dangerouslySetInnerHTML={{ __html: this.state.lbl_CallHelp }} />
                        </h2>
                    </div>
                )}
            </div>
        );
    }
}